import axios from "axios";
import { apiURL } from "../config/default";
import { alert } from "./alert";

export const register = (data) => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const _data = JSON.stringify(data);

  try {
    const res = await axios.post(`${apiURL}register`, _data, _config);
    return res;
  } catch (err) {
    const errors = err.response.data.error;

    if (Array.isArray(errors)) {
      errors.forEach((error) => {
        dispatch(
          alert(error.msg, "danger", {
            marginTop: "3em",
            marginBottom: "3em",
            width: "100%",
            marginBottom: "1%",
          })
        );
      });
    } else {
      dispatch(
        alert(errors, "danger", {
          marginTop: "3em",
          marginBottom: "3em",
          width: "100%",
          marginBottom: "1%",
        })
      );
    }
  }
};
